import { render } from "./OpenHoursComponent.vue?vue&type=template&id=1fcc79fd"
import script from "./OpenHoursComponent.vue?vue&type=script&lang=js"
export * from "./OpenHoursComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__